// extracted by mini-css-extract-plugin
module.exports = {"filters":"ModalAllGroups_filters__1THnC","scroll":"ModalAllGroups_scroll__9v4rJ","footer":"ModalAllGroups_footer__5Xe3_"};